import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ComputedPropertyInput from 'dashboard/apps/DashboardLayoutEditor/ComputedPropertyInput';
import { ModuleIframe } from 'dashboard/modules/Iframe/model';
import Spacer from 'design-system/components/Spacer';
import { Label } from 'design-system/components/Text';
import { JsonSchema } from 'lib/json-schema';

const Container = styled('div')`
  padding: ${Spacing[5]};
`;

export interface IframePanelProps {
  module: ModuleIframe;
  dataSchema: JsonSchema;
  updateModule: (module: ModuleIframe) => void;
}

const IframePanel = ({ module, dataSchema, updateModule }: IframePanelProps) => {
  return (
    <Container>
      <Label size='md' weight='bold'>
        Title
      </Label>
      <ComputedPropertyInput
        computedProperty={module.title}
        dataSchema={dataSchema}
        onComputedPropertyUpdate={(computedProperty) => {
          updateModule({ ...module, title: computedProperty });
        }}
      />
      <Spacer height={2} />
      <Label size='md' weight='bold'>
        URL
      </Label>
      <ComputedPropertyInput
        computedProperty={module.url}
        dataSchema={dataSchema}
        onComputedPropertyUpdate={(computedProperty) => {
          updateModule({ ...module, url: computedProperty });
        }}
      />
    </Container>
  );
};

export default IframePanel;
